'use client';

import type { News } from '@/types';

import BlogDesktop from './BlogDesktop';
import BlogMobile from './BlogMobile';

import { Box, Container } from '@/components';

const Blog: React.FC<{ news: News[] }> = ({ news }) => {
  return (
    <Container>
      <Box display={{ base: 'block', xl: 'none' }}>
        <BlogMobile blogs={news} />
      </Box>
      <Box display={{ base: 'none', xl: 'block' }}>
        <BlogDesktop blogs={news} />
      </Box>
    </Container>
  );
};
export default Blog;
